import { useState } from 'react';
import API_ROUTES from './apiRoutes';
import { useFetch } from './useFetch';

export const useDeleteAccount = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const { fetchWithAuth } = useFetch();

    const deleteAccount = async () => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await fetchWithAuth(API_ROUTES.USERS.deleteMe(), {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error('Falha ao excluir a conta');
            }

            setSuccess(true);
            localStorage.removeItem('token'); // Remove o token após deletar a conta
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return { deleteAccount, loading, error, success };
};
